"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGroup = void 0;
var react_1 = __importDefault(require("react"));
var FormGroup = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b;
    return (react_1.default.createElement("div", { className: "FormGroup mb-3 ".concat(className) }, children));
};
exports.FormGroup = FormGroup;
